import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { VacationBody } from '../entities/vacation-body';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import { AnnualIncome } from './../entities/annual-income';

@Injectable()
export class AnnualIncomeService extends BaseCrudService<AnnualIncome> {

  public uri = '/api/annualIncome/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance AnnualIncomeService');
  }

  buildSentence(entity?: AnnualIncome, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.status ?
          `status${QueryOperator.Equal}${entity.status}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.fiscalYear && entity.fiscalYear.id) {
        query = query.concat(
          `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
        );
      }
      if (entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
      if (entity.eu && entity.eu.id) {
        query = query.concat(
          `eu.id${QueryOperator.Equal}${entity.eu.id}${QueryOperator.Split}`
        );
      }
      if (entity.month && entity.month.id) {
        query = query.concat(
          `month.id${QueryOperator.Equal}${entity.month.id}${QueryOperator.Split}`
        );
      }
      if (entity.payrollConcept && entity.payrollConcept.id) {
        query = query.concat(
          `payrollConcept.id${QueryOperator.Equal}${entity.payrollConcept.id}${QueryOperator.Split}`
        );
      }
     //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  searchById(id: number): Observable<ResponsePageable<AnnualIncome>> {

    const url = `${this.rutaServidor}${this.uri}`;
   //console.log('RUTA DE BUSQUEDA ID');
   //console.log(url+id);
    return this.httpClient.get<any>(url+id);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/annual-income.service.ts